import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const teamsSlice = createSlice({
    name: "teams",
    initialState,
    reducers: {
        
    },
});

// export const {  } = teamsSlice.actions;
export default teamsSlice.reducer;
